import CopyButton from "../../../../common/CopyButton/CopyButton";
import CopyIcon from "../../../../Icon-SVG/CopyIcon";

import { getNestedValue } from "../../../../../utils/function";

const PhishBoxLink = (props) => {
  const accessor = props.column.id;
  const link = getNestedValue(props.row.original, accessor, "-");

  return (
    <div
      style={{
        display: "flex",
        gap: "4px",
      }}>
      <CopyButton
        title="Copy Link"
        itemToCopy={link}
        icon={CopyIcon}
        iconHeight={17}
        iconWidth={17}
        successMessage="Link Copied"
        failureMessage="Copy Failed"
      />
      <p title={link} className="shrink">
        {link}
      </p>
    </div>
  );
};

export default PhishBoxLink;
